function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "30",
  height: "30",
  viewBox: "0 0 30 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.03 17.314c0 .356.14.698.39.95l.56.566-4.6 4.681a1.624 1.624 0 01-2.322 0L.97 15.283a3.411 3.411 0 010-4.768l2.272-2.31a3.278 3.278 0 014.69 0l2.286 2.325 2.287-2.324a3.278 3.278 0 014.689 0l2.272 2.309a3.411 3.411 0 010 4.768l-.191.194-.56-.57a1.31 1.31 0 00-.935-.393c-.35 0-.686.141-.934.393l-1.43 1.455a1.351 1.351 0 00-.387.952zm7.923 6.668l-6.602-6.67 1.43-1.456 4.17 4.24V8.873h2.004v11.223l4.19-4.24 1.41 1.455-6.602 6.671z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("mask", {
  id: "a",
  maskUnits: "userSpaceOnUse",
  x: "0",
  y: "7",
  width: "30",
  height: "17"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.03 17.314c0 .356.14.698.39.95l.56.566-4.6 4.681a1.624 1.624 0 01-2.322 0L.97 15.283a3.411 3.411 0 010-4.768l2.272-2.31a3.278 3.278 0 014.69 0l2.286 2.325 2.287-2.324a3.278 3.278 0 014.689 0l2.272 2.309a3.411 3.411 0 010 4.768l-.191.194-.56-.57a1.31 1.31 0 00-.935-.393c-.35 0-.686.141-.934.393l-1.43 1.455a1.351 1.351 0 00-.387.952zm7.923 6.668l-6.602-6.67 1.43-1.456 4.17 4.24V8.873h2.004v11.223l4.19-4.24 1.41 1.455-6.602 6.671z",
  fill: "currentColor"
}))));